import React from "react";
import { invcsConnect } from "../../locales/en";

const AccountingSoftwareTitle = () => {
  return (
    <div className="home-title">
      <h1>{invcsConnect?.connectInvcs}</h1>
      <p className="sub-title">{invcsConnect?.clickOnYour}</p>
    </div>
  );
};

export default AccountingSoftwareTitle;
